// src/components/dashboard/Dashboard.jsx
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import MunicipalityDashboard from './MunicipalityDashboard';
import PADDStaffDashboard from './PADDStaffDashboard';
import KnowledgeBase from './KnowledgeBase';
import SuccessionPlanning from './SuccessionPlanning';

const C = {
  navy: '#122326', slate: '#213A3E', gold: '#BF6847',
  cream: '#F0EFEB', warm: '#F7F6F3', sand: '#E2E0DB', white: '#FFFFFF',
};

const TABS = [
  { key: 'applications', label: 'Applications' },
  { key: 'knowledge',    label: 'Knowledge Base' },
];

export default function Dashboard() {
  const { profile, signOut, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('applications');
  const [showSuccession, setShowSuccession] = useState(false);

  if (showSuccession) {
    return <SuccessionPlanning onBack={() => setShowSuccession(false)} />;
  }

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', backgroundColor: C.warm,
        fontFamily: "'Georgia', serif", color: C.navy,
      }}>
        Loading dashboard...
      </div>
    );
  }

  const isStaff = profile?.role === 'staff';

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.warm, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>

      {/* ── TOP BAR ── */}
      <div style={{ backgroundColor: C.navy, padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontFamily: "'Georgia', serif", fontSize: 18, fontWeight: 700, color: C.cream }}>
            PADD Hub
          </span>
          {isStaff && (
            <span style={{ backgroundColor: C.gold, color: C.white, padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600 }}>
              Staff
            </span>
          )}
          {!isStaff && profile?.municipalities?.name && (
            <span style={{ backgroundColor: C.slate, color: C.cream, padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600 }}>
              {profile.municipalities.name}
            </span>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 13, color: C.sand }}>
            {profile?.name || profile?.email}
          </span>
          <button
            onClick={signOut}
            style={{ backgroundColor: 'transparent', border: `1px solid ${C.slate}`, color: C.sand, padding: '6px 16px', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}
          >
            Log Out
          </button>
        </div>
      </div>

      {/* ── TAB BAR ── */}
      <div style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.sand}`, padding: '0 24px', display: 'flex', gap: 0 }}>
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            style={{
              padding: '14px 24px', fontSize: 14, fontWeight: activeTab === key ? 700 : 500,
              cursor: 'pointer', background: 'transparent', border: 'none',
              color: activeTab === key ? C.navy : C.slate,
              borderBottom: `3px solid ${activeTab === key ? C.gold : 'transparent'}`,
              marginBottom: -1,
              transition: 'all 0.15s',
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* ── TAB CONTENT ── */}
      {activeTab === 'applications' && (
        isStaff ? <PADDStaffDashboard /> : <MunicipalityDashboard />
      )}
      {activeTab === 'applications' && (
        <div style={{ padding: '24px', maxWidth: 900 }}>
          <div
            onClick={() => setShowSuccession(true)}
            style={{
              background: '#FFFFFF',
              border: '1px solid #E2E0DB',
              borderRadius: '12px',
              padding: '20px 24px',
              cursor: 'pointer',
              transition: 'box-shadow 0.15s',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '14px',
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
          >
            <div style={{
              width: '42px', height: '42px', borderRadius: '10px',
              background: '#F0EFEB', display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: '22px', flexShrink: 0,
            }}>
              🏢
            </div>
            <div>
              <div style={{ fontSize: '15px', fontWeight: 600, color: '#122326', marginBottom: '4px' }}>
                Succession Planning
              </div>
              <p style={{ fontSize: '13px', color: '#5a5a5a', lineHeight: 1.5, margin: 0 }}>
                Free, confidential support for business owners planning their next chapter. Questionnaire, checklist, and local resources.
              </p>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'knowledge' && <KnowledgeBase />}

    </div>
  );
}
